<template>
  <!-- max-[481px]:mx-[24px] -->
  <div
    v-if="item"
    class="flex flex-col items-start justify-between gap-[6px] p-[8px] pb-[14px] rounded-[6px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFFFFF]"
  >
    <div class="w-full flex flex-col items-start justify-center gap-[6px]">
      <div class="w-full relative pb-[100%] overflow-hidden">
        <img
          :src="item.image || 'https://placehold.co/230x230/png'"
          alt=""
          class="z-[0] absolute w-full h-full object-cover"
        />
      </div>
      <div class="title line-clamp-3">
        {{ item.title }}
      </div>
    </div>
    <div
      v-if="editAble"
      class="w-full flex items-center justify-between gap-[6px]"
    >
      <div
        class="w-full min-h-[42px] py-[8px] px-[10px] bg-[#9A247B] text-[#FFFFFF] text-center"
      >
        <span class="text_body truncate">
          {{ $formatDate1(item?.updated_at) }}
        </span>
      </div>

      <ButtonComponent
        v-if="editAble"
        :icon="'EditIcon'"
        :bClass="'btn_shadow--2 !min-w-[42px] min-h-[42px]'"
        :iClass="'w-fit h-fit'"
        @clicked="() => edit()"
      />
      <ButtonComponent
        :label="'อ่านต่อ'"
        :bClass="'btn_shadow--cancel max-h-[42px] !py-[8px] !px-[0px]'"
        :lClass="'truncate textButtonS'"
        @clicked="() => readMore()"
      />
    </div>
    <div v-else class="w-full flex items-center justify-between gap-[6px]">
      <div
        class="min-h-[42px] max-w-[106px] py-[8px] px-[20px] bg-[#9A247B] text-[#FFFFFF]"
      >
        <span class="text_body truncate">
          {{ $formatDate1(item?.updated_at) }}
        </span>
      </div>

      <ButtonComponent
        :label="'อ่านต่อ'"
        :bClass="'btn_shadow--cancel !max-w-[70px] max-h-[42px] !py-[8px] !px-[0px]'"
        :lClass="'truncate textButtonS'"
        @clicked="() => readMore()"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  editAble: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["read-more", "open-edit"]);

const readMore = () => {
  emit("read-more", props.item);
};
const edit = () => {
  emit("open-edit", props.item);
};
</script>

<style lang="scss" scoped>
.title {
  color: #1f1d1f;
  /* Blog card/title */
  font-family: Kanit;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 150% */
  letter-spacing: 0.1px;
}
.text_body {
  color: #fff;
  text-align: center;

  /* Blog card/label */
  font-family: Kanit;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 153.846% */
  letter-spacing: 0.1px;
}
</style>